import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
export const IconBoldSubtract = (props) => {
    const id = useId();
    return (<IconWithGradient id={id} {...props} defaultGradientKey="apricot">
      <Path fillRule="evenodd" clipRule="evenodd" d="M1 12C1 4.53882 4.53882 1 12 1C19.4612 1 23 4.53882 23 12C23 19.4612 19.4612 23 12 23C4.53882 23 1 19.4612 1 12ZM16 12C16 11.4477 15.5523 11 15 11H9C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13H15C15.5523 13 16 12.5523 16 12Z" fill={`url(#gradient_${id})`}/>
    </IconWithGradient>);
};
